import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const handleEmailClick = (email) => (e) => {
    // Eğer mailto çalışmazsa alternatif çözüm
    const mailtoLink = `mailto:${email}`;

    // Önce mailto'yu dene
    try {
      window.location.href = mailtoLink;
    } catch (error) {
      // Eğer mailto çalışmazsa, e-posta adresini panoya kopyala
      navigator.clipboard
        .writeText(email)
        .then(() => {
          alert(`E-posta adresi panoya kopyalandı: ${email}`);
        })
        .catch(() => {
          alert(`E-posta adresi: ${email}`);
        });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/images/logo.png"
                alt="RPM Kompresör Logo"
                className="logo-image"
              />
            </div>
            <p className="footer-description">
              Endüstriyel kompresör çözümlerinde güvenilir ortağınız. Kaliteli
              ürünler ve profesyonel hizmet anlayışımızla sektörde öncüyüz.
            </p>
            <div className="footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1000!2d32.738516!3d39.994509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d349f571b58411%3A0x71de0553c11abf82!2s%C4%B0vedik%20OSB%2C%201469.%20Sk.%20No%3A%2076!5e0!3m2!1str!2str!4v1757500000000!5m2!1str!2str"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="RPM Kompresör Konumu -  Arı Sanayi Sitesi, İvedik OSB, 1469 Sk. No: 76, 06378 Yenimahalle/Ankara"
              ></iframe>
            </div>
            <div className="dealer-badge">
              <img
                src="/images/aydin_trafo_logo.jpg"
                alt="Aydın Trafo Logo"
                className="dealer-logo"
              />
              <span className="dealer-text">
                Aydın Trafo Yetkili Bayisidir.
              </span>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Hızlı Linkler</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/hizmetler">Hizmetler</Link>
              </li>
              <li>
                <Link to="/urunler">Ürünler</Link>
              </li>
              <li>
                <Link to="/hakkimizda">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/kurumsal">Kurumsal</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">İletişim</h3>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Adres:</strong>
                <p>
                  Arı Sanayi Sitesi, İvedik OSB, 1469 Sk. No: 76
                  <br />
                  06378 Yenimahalle/Ankara
                </p>
              </div>
              <div className="contact-item">
                <strong>Telefon:</strong>
                <p>
                  <a href="tel:+905342137564" className="phone-link">
                    +90 0534 213 75 64
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <strong>E-posta:</strong>
                <p>
                  <a
                    href="mailto:info@rpmendustri.com"
                    className="email-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleEmailClick("info@rpmendustri.com")}
                  >
                    info@rpmendustri.com
                  </a>
                </p>
                <p>
                  <a
                    href="mailto:satis@rpmendustri.com"
                    className="email-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleEmailClick("satis@rpmendustri.com")}
                  >
                    satis@rpmendustri.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Çalışma Saatleri</h3>
            <div className="working-hours">
              <p>Pazartesi - Cumartesi: 08:00 - 17:30</p>
              <p>7/24 Destek</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 RPM Kompresör. Tüm hakları saklıdır.</p>
          <div className="social-links">
            <a
              href="https://wa.me/905342137564"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
